import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetPqrStatusHistory } from '../../../../../../services/pqr.service';
import { PqrStatusHistory } from '../../../../../../shared/types/modules/pqr';
import { TableTooltip } from '../../../../../components/general/table';
import { ISelect } from '../../../../../../shared/types/shared';
import { PqrStatusHistoryProps } from './props';
import DateTimeFormat from '../../../../../components/dateTimeFormat';

export const usePqrStatusHistory = ({ pqrId }: PqrStatusHistoryProps) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<PqrStatusHistory[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<PqrStatusHistory>[] = [
        {
            field: 'createdBy',
            headerName: 'Usuario',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.createdBy?.username || ''} />
            ),
        },
        {
            field: 'email',
            headerName: 'Email',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.pqrId?.account?.email || ''} />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={(row.row.changes.info?.status as ISelect)?.name}
                />
            ),
        },
        {
            field: 'observation',
            headerName: 'Observaciones',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.changes.statusManagement?.observation ||
                        row.row.previousState?.statusManagement?.observation ||
                        row.row.changes.info?.detail ||
                        ''
                    }
                />
            ),
        },
        {
            field: 'attach',
            headerName: 'Anexo',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={
                        row.row.changes.attachments
                            ?.map((item) => item.name)
                            .join(', ') || ''
                    }
                />
            ),
        },
    ];

    useEffect(() => {
        setLoading(true);
        asyncGetPqrStatusHistory(pqrId, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, pqrId]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
